export enum ShareOption {
  FACEBOOK = "facebook",
  TWITTER = "twitter",
  COPY_LINK ="copyLink",
  INSTAGRAM = "instagram",
  DOWNLOAD = "download",
  LINKEDIN = "linkedIn",
}